import { Box, Typography } from '@mui/material'
import { motion } from 'motion/react'
import { useState } from 'react'
import UseTranslation from '../../../hooks/UseTranslation'
import { ReactComponent as AttachmentIcon } from '../../../images/DownloadIcon.svg'
import { BtnsHoverAnimation } from '../../../utils/animation'
import AttachmentDownloaderModal from '../../Modals/AttachmentDownloaderModal'

const AttachmentDownloader = ({
  attachments, customStyle, showCount,
}) => {
  const { t } = UseTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Box
      sx={[styles.root, customStyle]}
      data-testid="attachment-downloader-root"
    >
      <Box sx={styles.btnContainer} onClick={() => setIsModalOpen(true)}>
        <Box
          sx={styles.icon}
          component={motion.div}
          variants={BtnsHoverAnimation}
          whileHover="hover"
        >
          <AttachmentIcon data-testid="download-icon" />
        </Box>
        <Typography variant="p2" sx={styles.text}>
          {showCount && `${attachments?.length || 0} `}
          {t?.Attachments}
        </Typography>
      </Box>
      <AttachmentDownloaderModal
        formModalState={isModalOpen}
        setFormModalState={setIsModalOpen}
        attachments={attachments}
      />
    </Box>
  )
}

const styles = {
  btnContainer: {
    display: 'flex', alignItems: 'flex-start', gap: '5px', cursor: 'pointer',
  },
  icon: {
    '& svg': {
      width: { xs: '15px', sm: '20px' }, height: { xs: '15px', sm: '20px' },
    },
  },
  text: {
    color: 'primary.main',
    textDecoration: 'underline',
  },
}
export default AttachmentDownloader
